import React from "react";
import ShopPromotionForm from "./ShopPromotionForm";

const AddShopPromotion = () => <ShopPromotionForm />;

export default AddShopPromotion;
